// MHSys Produktfragen (Roadmap 3.6 Paket B) - Link "Fragen zu diesem Artikel?" + aufklappendes
// Formular auf der Produktseite, hinter settings.mhsys_produktfragen (snippets/mhsys-produktfragen.liquid).
//
// Kein Popup: ein Knopf mit aria-expanded klappt ein Panel im Fluss der Seite auf (dasselbe Muster
// wie .mhsys-akkordeon). Escape im Panel schliesst es wieder und gibt den Fokus an den Knopf zurueck.
// Absenden per fetch() als JSON an /apps/kunde?bereich=fragen (mhsys-Repo, core/kundeninhalte.inc.php +
// extern/kundeninhalte/fragen/). Der Server meldet nie Details - bei jedem Fehler dieselbe, freundliche
// Meldung (Regel "Kunden sehen keine Fehler").
(function () {
  "use strict";

  var ENDPUNKT = "/apps/kunde?bereich=fragen";
  var MELDUNG_FEHLER = "Das hat gerade nicht geklappt. Bitte versuch es gleich noch einmal.";

  function einrichten(wurzel) {
    var knopf = wurzel.querySelector("[data-mhsys-pfr-oeffnen]");
    var panel = wurzel.querySelector("[data-mhsys-pfr-panel]");
    var form = wurzel.querySelector("[data-mhsys-pfr-form]");
    var fehler = wurzel.querySelector("[data-mhsys-pfr-fehler]");
    var danke = wurzel.querySelector("[data-mhsys-pfr-danke]");
    var senden = wurzel.querySelector("[data-mhsys-pfr-senden]");
    var honigtopf = form.querySelector('[name="website"]');
    /* Zeitstempel statt _dauer (Roadmap 7.59): window.mhsysStempel aus mhsys-kopf.js haengt _stempel an, warm geholt beim Oeffnen */
    function stempeln(r) { return window.mhsysStempel ? window.mhsysStempel.mit(r) : Promise.resolve(r); }

    function oeffnen() {
      panel.hidden = false;
      knopf.setAttribute("aria-expanded", "true");
      if (window.mhsysStempel) window.mhsysStempel.vor();
      var erstesFeld = form.querySelector('[name="frage"]');
      if (erstesFeld) erstesFeld.focus();
    }

    function schliessen() {
      panel.hidden = true;
      knopf.setAttribute("aria-expanded", "false");
      knopf.focus();
    }

    knopf.addEventListener("click", function () {
      if (panel.hidden) oeffnen();
      else schliessen();
    });

    panel.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        e.preventDefault();
        schliessen();
      }
    });

    function fehlerAnzeigen(text) {
      fehler.textContent = text;
      fehler.hidden = false;
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      // Honigtopf ausgefuellt: fuer einen Menschen unsichtbar, also ein Skript - nicht senden,
      // aber auch nicht als Fehler zeigen (kein Hinweis an einen Bot, dass er aufgefallen ist).
      if (honigtopf && honigtopf.value) return;

      if (!form.checkValidity()) {
        fehlerAnzeigen("Bitte Frage und E-Mail-Adresse ausfüllen.");
        return;
      }

      fehler.hidden = true;
      senden.disabled = true;
      var textVorher = senden.textContent;
      senden.textContent = "Wird gesendet…";

      var daten = new FormData(form);

      // Mit Zeitlimit (layout/theme.liquid, Roadmap 7.44): antwortet mhsys nicht, kommt der Hinweis statt "Wird gesendet…"
      stempeln({
        prod_id: wurzel.dataset.produktId,
        prva_id: wurzel.dataset.varianteId,
        frage: (daten.get("frage") || "").toString().trim(),
        email: (daten.get("email") || "").toString().trim(),
        vorname: (daten.get("vorname") || "").toString().trim(),
        website: (daten.get("website") || "").toString()
      }).then(function (rumpf) {
        return (window.mhsysNetz ? window.mhsysNetz.holen : fetch)(ENDPUNKT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(rumpf)
        });
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || !data || data.ok !== true) throw new Error("fehler");
          });
        })
        .then(function () {
          form.hidden = true;
          danke.hidden = false;
          danke.setAttribute("tabindex", "-1");
          danke.focus();
        })
        .catch(function () {
          fehlerAnzeigen(MELDUNG_FEHLER);
        })
        .finally(function () {
          senden.disabled = false;
          senden.textContent = textVorher;
        });
    });
  }

  function alleEinrichten() {
    document.querySelectorAll("[data-mhsys-pfr]").forEach(function (wurzel) {
      if (wurzel.dataset.mhsysPfrBereit) return;
      wurzel.dataset.mhsysPfrBereit = "1";
      einrichten(wurzel);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", alleEinrichten);
  } else {
    alleEinrichten();
  }
  document.addEventListener("shopify:section:load", alleEinrichten);

  // "Noch eine Frage?" am Ende von sections/mhsys-produktfragen-anzeige.liquid: oeffnet das
  // Formular oben im Kaufbereich, statt zu einem verdeckten (hidden) Panel zu springen, das ohne
  // Klick auf den eigentlichen Knopf leer bliebe.
  document.addEventListener("click", function (e) {
    var link = e.target.closest("[data-mhsys-pfr-sprung]");
    if (!link) return;
    var wurzel = document.querySelector("[data-mhsys-pfr]");
    var knopf = wurzel ? wurzel.querySelector("[data-mhsys-pfr-oeffnen]") : null;
    if (!knopf) return;
    e.preventDefault();
    if (knopf.getAttribute("aria-expanded") !== "true") knopf.click();
    wurzel.scrollIntoView({ behavior: "smooth", block: "center" });
  });

  // "Fragen?" aus der Schnellansicht (Roadmap 3.25) kommt als Link mit #mhsys-pfr-panel-<id> - das Panel
  // ist beim Laden versteckt, der Browser faende nichts zum Hinscrollen. Deshalb hier oeffnen und hinscrollen.
  function ausAdresseOeffnen() {
    if (location.hash.indexOf("#mhsys-pfr-panel-") !== 0) return;
    var wurzel = document.querySelector("[data-mhsys-pfr]");
    var knopf = wurzel ? wurzel.querySelector("[data-mhsys-pfr-oeffnen]") : null;
    if (!knopf) return;
    if (knopf.getAttribute("aria-expanded") !== "true") knopf.click();
    // Beim DOMContentLoaded fehlen oben noch Bildhoehen - nach dem Laden noch einmal, sonst steht das
    // Formular nach dem Nachladen der Galerie weit unterhalb des Sichtbereichs (gemessen: 1399 px bei 812)
    var hin = function () { wurzel.scrollIntoView({ block: "center" }); };
    hin();
    if (document.readyState === "complete") setTimeout(hin, 300);
    else window.addEventListener("load", function () { setTimeout(hin, 100); }, { once: true });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ausAdresseOeffnen);
  } else {
    ausAdresseOeffnen();
  }
})();
